module.exports = __webpack_public_path__ + "img/tab-dashboard-inactive.0a240477.svg";